import { Asset } from "assets.gen";

const FONTS: readonly { src: string; family: string }[] = [
  { src: Asset.font_acme_caps_outline, family: "grixel" },
  { src: Asset.font_press_start, family: "press-start" },
];

export function loadFonts(): Promise<void>[] {
  return FONTS.map(({ src, family }) => loadFont(src, family));
}

export async function loadFont(src: string, family: string): Promise<void> {
  const font = new FontFace(family, `url(${src})`);
  const loaded = await font.load();
  document.fonts.add(loaded);
}
